import axios from "axios";
const BASE_API_URL = process.env.REACT_APP_API_URL;
// =================Emp Education URL=====================
// export const Customer_Register_Details = `${BASE_API_URL}/Customer/RegisterCustomer`;
// export const VerifyOtp = `${BASE_API_URL}/customer/VerifyOtp`;
// export const Customer_Login = `${BASE_API_URL}/Customer/CustomerLogin`;
// export const Customer_Forgot_Password = `${BASE_API_URL}/Customer/ForgetPassword_ByMobile`;
// export const Get_State_GetBy_CountryID = `${BASE_API_URL}/State/State_GetBy_CountryID`;
// export const Get_State_Add_Customer_Address = `${BASE_API_URL}/Customer/AddCustomerAddress`;
// export const Get_State_Get_Customer_Addresses_By_CustomerID = `${BASE_API_URL}/Customer/GetCustomerAddresses_ByCustomerID`;
// export const DeleteCustomerAddress = `${BASE_API_URL}/Customer/DeleteCustomerAddress`;
// export const OTP_GenerateByCustomerID = `${BASE_API_URL}/Order/OTP_GenerateByCustomerID`;
// export const OTP_VerificationByCustomerID = `${BASE_API_URL}/Order/OTP_Verification`;
export const CustomerOrder_PlaceByCustomerID = `${BASE_API_URL}/Order/CustomerOrder_Place`;
export const CustomerOrder_PlaceByCustomerID_2 = `${BASE_API_URL}/Order/CustomerOrder_Place_2`;
export const PaymentSave = `${BASE_API_URL}/Order/PaymentSave`;
export const ItemQtyRateMap_ActiveList_Dropdown = `${BASE_API_URL}/ItemQtyRateMap/ItemQtyRateMap_ActiveList_Dropdown`;
export const Order_GetAll_Filter = `${BASE_API_URL}/Order/Order_GetAll_Filter` //Get Filter Employee Page //Get Filter Employee Page
export const GetProductList_ByOrderID = `${BASE_API_URL}/Order/GetProductList_ByOrderID` //Get Filter Employee Page

// -------------------------------------------

export function itemQtyRateMapActiveList_Dropdown(productID) {
  return axios.post(ItemQtyRateMap_ActiveList_Dropdown, { productID });
}
export function paymentSaveApi(orderID, paymentModeID, paidAmount) {
  return axios.post(PaymentSave, { orderID, paymentModeID, paidAmount });
}
export function placeCustomerOrderApi(payload) {
  return axios.post(CustomerOrder_PlaceByCustomerID, payload);
}
export function placeCustomerOrderApi_2(payload) {
  return axios.post(CustomerOrder_PlaceByCustomerID_2, payload);
}
// export function deleteCustomerAddressApi(customerAddressID) {
//   return axios.post(DeleteCustomerAddress, { customerAddressID });
// }

// Get all addresses
// export function otp_VerificationApi(customerID, otp) {
//   return axios.post(OTP_VerificationByCustomerID, {
//     customerID,
//     otp,
//   });
// }

// export function getGenerateByCustomerIDApi(customerID) {
//   return axios.post(OTP_GenerateByCustomerID, {
//     customerID,
//   });
// }

// export function getStateGetCustomerAddressesByCustomerIDApi(customerID) {
//   return axios.post(Get_State_Get_Customer_Addresses_By_CustomerID, {
//     customerID,
//   });
// }
// export function getStateGetByCountryIDApi(countryID) {
//   return axios.post(Get_State_GetBy_CountryID, {
//     countryID,
//   });
// }

// Add a new customer address
// export function addCustomerAddressApi(
//   customerID,
//   stateID,
//   cityName,
//   pincode,
//   addressLine1,
//   addressLine2,
//   createBy,
//   ipAddress
// ) {
//   const addressData = {
//     customerID,
//     stateID,
//     cityName,
//     pincode,
//     addressLine1,
//     addressLine2,
//     createBy,
//     ipAddress,
//   };

//   return axios.post(Get_State_Add_Customer_Address, addressData);
// }
// ---------------------------------
// export function forgotPasswordByMobileApi(mobileNumber, newPassword) {
//   return axios.post(Customer_Forgot_Password, { mobileNumber, newPassword });
// }

// // ----------------
// export function customerLoginApi(mobileOrEmail, password) {
//   return axios.post(Customer_Login, {
//     mobileOrEmail,
//     password,
//   });
// }
// export function customerRegisterDetailsApi(
//   firstName,
//   lastName,
//   mobileNumber,
//   email,
//   password,
//   ipAddress,
//   createBy
// ) {
//   return axios.post(Customer_Register_Details, {
//     firstName,
//     lastName,
//     mobileNumber,
//     email,
//     password,
//     ipAddress,
//     createBy,
//   });
// }
// // -------------------------------
// export function verifyOtpApi(mobileNumber, otp, customerID) {
//   return axios.post(VerifyOtp, {
//     mobileNumber,
//     otp,
//     customerID,
//   });
// }
export function getOrder_GetAll_FilterList(
  pageNumber,
  pageSize,
  customerID,
  countryID,
  searchText,
  orderDateFrom,
  orderDateTo,
  selDate,
  statusID,
) {
  return axios.post(Order_GetAll_Filter, {
    pageNumber,
    pageSize,
    customerID,
    countryID,
    searchText,
    orderDateFrom,
    orderDateTo,
    selDate,
    statusID,
  });
}

export function GetProductList_ByOrderIDAPI(orderID) {
  return axios.post(GetProductList_ByOrderID, {orderID})
}